module.exports = __webpack_public_path__ + "static/media/banner_01.84c148c7.svg";